import React, {FC} from "react"

import success from "@irati/ui/images/success.svg"
import {H2, Body} from "@irati/ui/src/Typography"
import id from "@irati/utils/id"
import {FormattedMessage, LangLoader} from "@irati/utils/lang"
import {ACCOUNT} from "@irati-web/app/src/routeConfig"
import GenericModal from "@irati/ui/src/GenericModal"

interface Props {
  messageId?: string
  onHide?: () => void
}

const PasswordSavedModal: FC<Props> = (props) => {
  const idNamespace = id("password-saved-modal", props)
  const {messageId, onHide} = props

  return (
    <LangLoader bucket={ACCOUNT}>
      <GenericModal id={idNamespace} show hideActions image={success} onHide={onHide} style={{marginTop: "110px"}}>
        <H2 id={id("title", idNamespace)}>
          <FormattedMessage id="account.password.updateSuccessful" />
        </H2>
        {messageId && (
          <Body marginTop={3}>
            <FormattedMessage id={messageId} />
          </Body>
        )}
      </GenericModal>
    </LangLoader>
  )
}

export default PasswordSavedModal
